<template>
  <ul class="dropdown-menu dropdown-menu-end lh-lg">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'DropdownMenu',
}
</script>
